import React from "react";

export const NotesPdfCard = ({ img }) => {
	return (
		<div className="w-80 h-64 border rounded-lg p-3 hover:shadow-2xl shadow-md relative">
			<div className="w-full h-full relative overflow-hidden flex flex-col items-center justify-between">
				<div className="w-full h-[58%] overflow-hidden rounded-lg flex justify-center">
					<img
						src={img}
						className="w-32 h-32 object-center"
						alt="notes"
					/>
				</div>
				<h3 className="text-lg font-semibold">Free Tutorial</h3>
				<div className="w-[50%] h-[50%] bg-gray-400 opacity-50 rounded-s-full rotate-45 absolute -bottom-12 -right-12"></div>
				<div className="w-[30%] h-[35%] bg-gray-400 opacity-50 rounded-full rotate-45 absolute top-[40%] -right-12"></div>
				<p>Download CheatSheet Here</p>
				<button className="bg-orange-600 rounded-full px-4 py-1 text-white font-medium w-44">
					Download
				</button>
			</div>
		</div>
	);
};
const NotesCard = ({ img }) => {
	return (
		<div className="w-80 h-72 border rounded-lg p-3 hover:shadow-2xl shadow-md relative">
			<div className="w-full h-full relative overflow-hidden flex flex-col items-center justify-between">
				<div className="w-full h-[50%] overflow-hidden rounded-lg flex justify-center">
					<img
						src={img}
						className="w-32 h-32 object-center"
						alt="notes"
					/>
				</div>
				<h3 className="text-lg font-semibold">Free Tutorial</h3>
				<div className="w-[50%] h-[50%] bg-gray-400 opacity-50 rounded-s-full rotate-45 absolute -bottom-12 -right-12"></div>
				<p>Download Notes Here</p>
				<div className="w-[30%] h-[35%] bg-gray-400 opacity-50 rounded-full rotate-45 absolute top-[40%] -right-12"></div>
				<button className="bg-orange-600 rounded-full px-4 py-1 text-white font-medium w-44">
					PDF Notes
				</button>
				<button className="bg-orange-600 rounded-full px-4 py-1 text-white font-medium w-44">
					Chapterwise Notes
				</button>
			</div>
		</div>
	);
};

export default NotesCard;
